/*
General-purpose error catching class for the app. 
Based on the docs at https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
*/

import React from "react";
import * as Sentry from "@sentry/react";
import { GiSadCrab } from "react-icons/gi";
import Feedback from "./containers/Feedback";


function ErrorPage() {
  return (
    <div className='mt-4'>
      <div className='d-flex'>
        <div className='mx-auto position-relative' style={{ width: '50px', height: '74px' }}>
          <img src='/android-chrome-192x192.png' alt='crossworthy-eaten-by-crab' width={40} style={{ position: 'absolute', top: '0px', left: '-4px', transform: 'rotate(-35deg)' }} />
          <GiSadCrab className='zoomable' size={50} style={{ position: 'absolute', bottom: '2px', right: '4px', color: '#8B0000' }} />
        </div>
      </div>

      <p className='mx-auto text-center not-too-wide'>We did something wrong! You just found a bug in our app. No biggie&mdash;<strong>refresh the page</strong> to get back to where you were.</p>
      <p className='mx-auto text-center not-too-wide'>If you're able to give us any context into what happened, we may be able to fix it more quickly!</p>


      <Feedback formOnly />
    </div>
  );
}


export default function ErrorCatcher({ children }) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorPage />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}

